import { TextField, Typography } from "@mui/material";
import type { OnboardingAnswers } from "../../types/onboarding";
import { EMAIL_MESSAGE } from "../../utils/storefrontFields";
import DateField from "./DateField";

export default function ClientSection({ answers, set, companyLocked, agreementOptional, missingFields }: {
  answers: OnboardingAnswers;
  set: (patch: Partial<OnboardingAnswers>) => void;
  companyLocked: boolean;
  agreementOptional: boolean;
  missingFields: ReadonlySet<string>;
}) {
  const setAdmin = (patch: Partial<OnboardingAnswers["admin"]>) => set({ admin: { ...answers.admin, ...patch } });

  return (
    <>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <TextField
          label="Company name" value={answers.companyName} size="small" fullWidth error={missingFields.has("companyName")}
          onChange={(e) => set({ companyName: e.target.value })}
          slotProps={{ htmlInput: { readOnly: companyLocked } }}
          sx={companyLocked ? { bgcolor: "action.hover" } : undefined}
        />
        <TextField
          label={agreementOptional ? "Legal entity (optional)" : "Legal entity, as on the agreement"} value={answers.legalEntity} size="small" fullWidth
          error={missingFields.has("legalEntity")}
          onChange={(e) => set({ legalEntity: e.target.value })}
        />
        <DateField
          label={agreementOptional ? "New agreement signed on (optional)" : "Agreement signed on"} value={answers.signedOn}
          error={missingFields.has("signedOn")} onChange={(signedOn) => set({ signedOn })}
        />
        <TextField
          label="Communications channel (optional)" placeholder="e.g. #follic-labs on Slack" value={answers.commsChannel ?? ""} size="small" fullWidth
          onChange={(e) => set({ commsChannel: e.target.value })}
        />
      </div>
      <div>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Client admin</Typography>
        <Typography variant="body2" color="text.secondary">Our main contact. Their portal login is a checklist step, not created now.</Typography>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <TextField
          label="First name" value={answers.admin.firstName} size="small" fullWidth error={missingFields.has("admin.firstName")}
          onChange={(e) => setAdmin({ firstName: e.target.value })}
        />
        <TextField
          label="Last name" value={answers.admin.lastName} size="small" fullWidth error={missingFields.has("admin.lastName")}
          onChange={(e) => setAdmin({ lastName: e.target.value })}
        />
        <TextField
          label="Email" type="email" value={answers.admin.email} size="small" fullWidth
          error={missingFields.has("admin.email") || missingFields.has("admin.emailFormat")}
          helperText={missingFields.has("admin.emailFormat") ? EMAIL_MESSAGE : null}
          onChange={(e) => setAdmin({ email: e.target.value })}
        />
      </div>
    </>
  );
}
